/* ====================================
*            ANGULAR IMPORTS
======================================= */

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

/* ====================================
*            PRIMENG IMPORTS
======================================= */

import { ToastModule } from "primeng/toast";
import { MessageService } from "primeng/api";
import { FileUploadModule } from "primeng/fileupload";
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from "primeng/table";
import { TooltipModule } from "primeng/tooltip";
import { InputSwitchModule } from "primeng/inputswitch";
import { PanelModule } from "primeng/panel";
import { InputTextareaModule } from "primeng/inputtextarea";
import { AccordionModule } from "primeng/accordion";
import { TabViewModule } from "primeng/tabview";
import { RadioButtonModule } from "primeng/radiobutton";
import { DropdownModule } from "primeng/dropdown";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { MessagesModule } from "primeng/messages";
import { MessageModule } from "primeng/message";
import { SelectButtonModule } from "primeng/selectbutton";
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { SkeletonModule } from "primeng/skeleton";
import { PaginatorModule } from "primeng/paginator";
import { DialogModule } from "primeng/dialog";
import { TagModule } from "primeng/tag";
import { ToggleButtonModule } from "primeng/togglebutton";
import { MultiSelectModule } from "primeng/multiselect";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { SidebarModule } from "primeng/sidebar";
import { ButtonModule } from "primeng/button";
import { ChipsModule } from "primeng/chips";
import { ProgressBarModule } from "primeng/progressbar";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { PasswordModule } from "primeng/password";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { TerminalModule } from "primeng/terminal";
import { CalendarModule } from "primeng/calendar";
import { CheckboxModule } from "primeng/checkbox";
import { SpeedDialModule } from "primeng/speeddial";
import { TranslateModule } from "@ngx-translate/core";
import { BadgeModule } from "primeng/badge";
import { ImageModule } from "primeng/image";
import { AvatarModule } from "primeng/avatar";
import { ColorPickerModule } from "primeng/colorpicker";
import { OrganizationChartModule } from "primeng/organizationchart";
import { SplitButtonModule } from "primeng/splitbutton";
import { DividerModule } from "primeng/divider";
import { CarouselModule } from "primeng/carousel";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { GalleriaModule } from "primeng/galleria";
// import { ChartModule } from 'primeng/chart';
import { MenuModule } from "primeng/menu";
import { StepsModule } from "primeng/steps";

@NgModule({
  imports: [CommonModule],
  exports: [
    InputTextModule,
    GalleriaModule,
    TableModule,
    TooltipModule,
    InputSwitchModule,
    PanelModule,
    InputTextareaModule,
    AccordionModule,
    TabViewModule,
    RadioButtonModule,
    MenuModule,
    DropdownModule,
    ProgressSpinnerModule,
    MessagesModule,
    MessageModule,
    SelectButtonModule,
    SkeletonModule,
    ConfirmPopupModule,
    PaginatorModule,
    ToggleButtonModule,
    TagModule,
    DialogModule,
    ToastModule,
    FileUploadModule,
    DynamicDialogModule,
    ProgressBarModule,
    ChipsModule,
    ButtonModule,
    SidebarModule,
    BreadcrumbModule,
    MultiSelectModule,
    PasswordModule,
    OverlayPanelModule,
    CalendarModule,
    TerminalModule,
    CheckboxModule,
    SpeedDialModule,
    TranslateModule,
    BadgeModule,
    ImageModule,
    AvatarModule,
    ColorPickerModule,
    DividerModule,
    SplitButtonModule,
    OrganizationChartModule,
    CarouselModule,
    ConfirmDialogModule,
    StepsModule,
  ],
  providers: [MessageService],
})
export class SharedUiModule {}
